import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    emptySelector: {
        marginTop: 25,
    },
});

export default styles;
